import React, { Fragment, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import styles from "./Breadcrumb.module.css";

export interface BreadcrumbItem {
  name: string;
  path: string;
}

interface Props {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<React.PropsWithChildren<Props>> = ({
  items,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!ref.current || ref.current.clientWidth <= 0) return;
    ref.current.scrollTo({ left: ref.current.clientWidth, behavior: "smooth" });
  }, [items]);

  return (
    <div className={styles.breadcrumbInner} ref={ref}>
      {items.map((item, i) => (
        <Fragment key={i}>
          <NavLink
            end
            className={({ isActive }) =>
              styles.breadcrumb + (isActive ? styles.breadcrumbActive : "")
            }
            to={{
              pathname: item.path,
            }}
          >
            {item.name}
          </NavLink>
          {i < items.length - 1 && (
            <span className={styles.breadcrumbSeparator}>&#62;</span>
          )}
        </Fragment>
      ))}
    </div>
  );
};
